var App = App || {};

App.Base = (function ($) {
    'use strict';

    let bsElements;
    const speedBumpModal = $("#ModalSpeedbump");
    const speedBumpExempt = SpeedbumpData.ExemptList;

    function BsElements() {

        const elements = {
            accPanels: [...$("[data-bs-toggle='collapse']")].filter(x => x.id != "").map(x => `#${x.id}`),
            tabPanels: [...$("[data-bs-toggle='tab']")].filter(x => x.id != "").map(x => `#${x.id}`),
            modals: [...$(".modal")].filter(x => x.id != "").map(x => `#${x.id}`)
        };
        bsElements = elements;

        const hash = location.hash;
        const bsType = BsElementsCheck(hash);
        if (bsType != false) {
            $(document).ready(function () {
                BsElementsExecute(hash, bsType);
            });
        }
    }

    function BsElementsCheck(hash) {
        hash = hash.includes("?") ? hash.split("?")[0] : hash;
        for (const key in bsElements) {
            if (bsElements[key].includes(hash)) {
                return key;
            }
        }
        return false;
    }

    function BsElementsExecute(href, bsType) {
        const hash = href.includes("?") ? href.split("?")[0] : href;
        const search = href.includes("?") ? `?${href.split("?")[1]}` : null;

        if (bsType == "accPanels") {
            const target = $($(hash).attr("data-bs-target"));
            target.collapse("show");
        }
        else if (bsType == "tabPanels") {
            const target = $(hash);
            target.tab("show");
        }
        else if (bsType == "modals") {
            const target = $(hash);
            sessionStorage.setItem("OpenAccountProductId", search);
            target.modal("show");
        }
    }

    function SpeedBumpCheck(hostname, href) {

        if (hostname !== location.hostname
            && $.inArray(hostname, speedBumpExempt) === -1
            && href
            && href.indexOf("#") !== 0
            && !IsUriSchema(href)) {
            return true;
        }

        return false;
    }

    function SpeedBumpExecute(href, parentModal) {

        // if speedbump was opened from a modal temporarily close modal when speedbump opens reopen modal when speedbump closes
        if (parentModal != null) {
            parentModal.modal("hide");
            speedBumpModal.on("hidden.bs.modal", function () {
                parentModal.modal("show");
            })
        }

        speedBumpModal.modal("show");
        speedBumpModal.find("button[data-bs-proceed='modal']")
            .off("click")
            .on("click", function () {
                speedBumpModal.modal("hide");
                window.open(href);
            }
            );
    }

    function IsUriSchema(href) {

        const uriSchemes = ["javascript:", "mailto:", "tel:"];

        for (var i in uriSchemes) {
            if (href.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    function ClickSupport(selector) {

        selector.on("click", function (e) {

            const hostname = this.hostname;
            const href = $(this).attr("href");

            // check against speedbump
            if (SpeedBumpCheck(hostname, href)) {
                e.preventDefault();
                // see if the speedbump is triggered from within a modal that we would come back to
                const parentModal = $(this).parents(".modal");
                SpeedBumpExecute(href, parentModal);
            }
            else if (href.startsWith("#")) {
                // check against known bootstrap elements
                const bsType = BsElementsCheck(href);
                if (bsType != false) {
                    if (bsType == "modals") { e.preventDefault(); }
                    BsElementsExecute(href, bsType);
                }
            }

        });

    }

    function RichTextResponsiveTables(selector) {
        selector.each(function () {
            if (!$(this).parent().hasClass("table-responsive")) {
                $(this).wrap("<div class=\"table-responsive\"></div>")
            }
        });
    }

    function ZagParallaxExample() {
        $(".page-masthead .page-masthead-image").ZagParallax({ divisor: 2 });
    }

    function ZagScrollAnimateExample() {

        $(".page-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".page-masthead-title", type: "animate__fadeInLeft", stagger: 0 },
                { selector: ".page-masthead-rich-text", type: "animate__fadeInRight", stagger: 0 },
                { selector: ".page-masthead-ctas > ul > li", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name, url = location.search) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(url);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    function FocusSend(target) {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        target.removeAttribute('tabindex');
    }

    function FocusTrap(parent, release, descendants = []) {

        FocusSend(parent[0]);

        // container or containers of potentially focusable elements for which we want to trap focus or have trapped focus
        const focusGroups = descendants.length ? descendants.reduce((acc, t) => acc.add(t), $()) : parent;

        // if FocusTrap is called with release = true then remove event listeners and exit
        if (release) {
            focusGroups.off("keydown");
            $(".modal").off("show.bs.modal.customFocusTrap hide.bs.modal.customFocusTrap");
            return;
        }

        // Build list of focusable elements contained within focusGroups
        const focusSelectors = ['a[href]', 'button', 'input', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'].join(',');
        const focusItems = focusGroups.find(focusSelectors).toArray();

        // hijack keydown events within focusGroups to implement focus trap
        focusGroups.on("keydown", function (e) {

            if (e.key !== 'Tab') return;
            e.preventDefault();
            const focusItemsVisible = focusItems.filter(el => el.offsetParent !== null);
            const currentIndex = focusItemsVisible.indexOf(document.activeElement);

            if (e.shiftKey) {
                if (currentIndex === 0) {
                    e.preventDefault();
                    focusItemsVisible[focusItemsVisible.length - 1].focus();
                }
                else {
                    focusItemsVisible[currentIndex - 1].focus();
                }
            }
            else {
                if (currentIndex === focusItemsVisible.length - 1) {
                    e.preventDefault();
                    focusItemsVisible[0].focus();
                }
                else {
                    focusItemsVisible[currentIndex + 1].focus();
                }
            }
        });

        // track which focusable was clicked to trigger a modal so we can return focus when modal closes
        let modalReturnFocus = null;
        $(".modal").on("show.bs.modal.customFocusTrap", function () {
            modalReturnFocus = document.activeElement;
        });
        $(".modal").on("hidden.bs.modal.customFocusTrap", function () {
            modalReturnFocus.focus();
        });
    }

    return {
        BsElements: BsElements,
        BsElementsCheck: BsElementsCheck,
        BsElementsExecute: BsElementsExecute,
        SpeedBumpCheck: SpeedBumpCheck,
        SpeedBumpExecute: SpeedBumpExecute,
        IsUriSchema: IsUriSchema,
        ClickSupport: ClickSupport,
        RichTextResponsiveTables: RichTextResponsiveTables,
        ZagParallaxExample: ZagParallaxExample,
        ZagScrollAnimateExample: ZagScrollAnimateExample,
        GetUrlParameter: GetUrlParameter,
        FocusSend: FocusSend,
        FocusTrap, FocusTrap
    };

})(jQuery);

$(function () {
    App.Base.BsElements();
    App.Base.ClickSupport($("a"));
    App.Base.RichTextResponsiveTables($(".rich-text table.table"));
    App.Base.ZagParallaxExample();
    App.Base.ZagScrollAnimateExample();
});